import React from "react";

/**
 * DS Radio — figma 323:4934 / 323:4940.
 *
 * 16×16 circle.
 *  - unchecked: white bg + border 1px Border/Default
 *  - checked: white bg + border 5px Text/Secondary (thick ring, inner is bg white)
 *
 * @param {object} props
 * @param {string} [props.name]
 * @param {string|number} [props.value]
 * @param {boolean} props.checked
 * @param {(value: string|number) => void} props.onChange
 * @param {string} [props.label]
 */
const DSRadio = ({ name, value, checked, onChange, label, disabled }) => {
  return (
    <label className="ds-radio">
      <input
        type="radio"
        className="ds-radio__input"
        name={name}
        value={value}
        checked={!!checked}
        disabled={disabled}
        onChange={() => onChange && onChange(value)}
      />
      <span className={`ds-radio__circle ${checked ? "ds-radio__circle--checked" : ""}`} />
      {label != null && <span className="ds-radio__label">{label}</span>}
    </label>
  );
};

export default React.memo(DSRadio);
